import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons'
import clsx from 'clsx'
import type { ReactElement } from 'react'
import type { FallbackProps } from 'react-error-boundary'
import { ButtonGroup } from '~/components/Global/Blocks/ButtonGroup/ButtonGroup'
import { Modal } from '~/components/Global/Design/Modal/Modal'
import {
  content as contentModalStyle,
  inner as innerModalStyle
} from '~/components/Global/Design/Modal/Modal.css'
import { ErrorDetails } from '~/components/Global/Elements/ErrorDetails/ErrorDetails'
import { NoResult } from '~/components/Global/Elements/NoResult/NoResult'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { CloseTrigger } from '~/components/Global/Interactions/CloseTrigger/CloseTrigger'
import { themeClass } from '~/styles/theme.css'

interface ApplicationModalErrorFallbackProps extends FallbackProps {
  onClose: () => void
}

export const ApplicationModalErrorFallback = ({
  error,
  resetErrorBoundary,
  onClose
}: ApplicationModalErrorFallbackProps): ReactElement => {
  const handleRetry = () => {
    resetErrorBoundary()
  }

  const handleClose = () => {
    resetErrorBoundary()
    onClose()
  }

  return (
    <Modal onClose={handleClose} open={true}>
      <div className={clsx(themeClass)}>
        <div className={clsx(innerModalStyle)}>
          <CloseTrigger onClose={handleClose} />
          <section className={contentModalStyle}>
            <NoResult
              icon={faExclamationTriangle}
              isError={true}
              message="Une erreur est survenue"
              description="Une erreur inattendue s'est produite lors de l'affichage de cette candidature."
            />
            {error ? <ErrorDetails error={error} /> : null}
            <ButtonGroup align="center">
              <Button variation={ButtonVariation.Primary} onClick={handleRetry}>
                Réessayer
              </Button>
              <Button
                variation={ButtonVariation.Secondary}
                onClick={handleClose}
              >
                Fermer
              </Button>
            </ButtonGroup>
          </section>
        </div>
      </div>
    </Modal>
  )
}
